type Tab = {
  $control: HTMLButtonElement;
  $pane: HTMLElement;
};

export default class Tabs {
  private $innerWrapper: HTMLElement;

  private $previousDirectionButton: HTMLButtonElement;
  private $nextDirectionButton: HTMLButtonElement;

  private innerWrapperPosition: number = 0;

  private currentTab: number = -1;

  private tabs: Tab[] = [];

  constructor($wrapper: HTMLElement) {
    this.$previousDirectionButton = $wrapper.querySelector<HTMLButtonElement>('.tc-tabs__controls__direction.is-previous');
    this.$nextDirectionButton = $wrapper.querySelector<HTMLButtonElement>('.tc-tabs__controls__direction.is-next');

    this.$innerWrapper = $wrapper.querySelector<HTMLElement>('.tc-tabs__controls__inner-wrapper');

    $wrapper.querySelectorAll<HTMLButtonElement>('.tc-tabs__control').forEach(($control, index) => {
      $control.setAttribute('data-index', `${index}`);

      const identifier = $control.getAttribute('data-tab');

      const tab: Tab = {
        $control,
        $pane: $wrapper.querySelector(`.tc-tabs__pane[data-tab="${identifier}"]`),
      };

      if ($control.classList.contains('is-active')) {
        this.currentTab = index;

        tab.$pane.classList.add('is-active');
      }

      this.tabs.push(tab);

      $control.addEventListener('click', this.onControlClick);
    });

    this.$previousDirectionButton.addEventListener('click', this.onDirectionButtonClick);
    this.$nextDirectionButton.addEventListener('click', this.onDirectionButtonClick);

    if (this.currentTab === -1) {
      this.currentTab = 0;
    }

    this.setTab(this.currentTab);
  }

  private setTab(index: number) {
    // Make the currently active tab inactive.
    if (this.currentTab !== -1) {
      const currentTab = this.tabs[this.currentTab];

      currentTab.$control.classList.remove('is-active');
      currentTab.$pane.classList.remove('is-active');
    }

    // Set the new active tab.
    const tab = this.tabs[index];

    tab.$control.classList.add('is-active');
    tab.$pane.classList.add('is-active');

    this.currentTab = index;

    // Set the `disabled' state of the direction buttons.
    if (this.currentTab === 0) {
      this.$previousDirectionButton.setAttribute('disabled', 'disabled');
    } else {
      this.$previousDirectionButton.removeAttribute('disabled');
    }

    if (this.currentTab === (this.tabs.length - 1)) {
      this.$nextDirectionButton.setAttribute('disabled', 'disabled');
    } else {
      this.$nextDirectionButton.removeAttribute('disabled');
    }
  }

  private onControlClick = (event: MouseEvent): void => {
    event.preventDefault();

    const index = parseInt((event.target as HTMLButtonElement).getAttribute('data-index'));

    this.setTab(index);
  };

  private onDirectionButtonClick = (event: MouseEvent): void => {
    event.preventDefault();

    const currentTab = this.tabs[this.currentTab];
    const $target = (event.target as HTMLElement).closest<HTMLButtonElement>('button');

    if ($target.classList.contains('is-next')) {
      this.innerWrapperPosition -= (currentTab.$control.getBoundingClientRect().width + 5);

      this.setTab(this.currentTab + 1);
    } else {
      this.innerWrapperPosition += (this.tabs[this.currentTab - 1].$control.getBoundingClientRect().width + 5);

      this.setTab(this.currentTab - 1);
    }

    // this.$innerWrapper.style.transform = `translateX(${this.innerWrapperPosition}px)`;
  };
};
